import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosapi from "../utilities/axiosApi";

export const userLogin = createAsyncThunk(
    'user/login',
    async (loginDetails, { rejectWithValue }) => {
      try {
        const response = await axiosapi.post('/api/auth/login', loginDetails);
        return response.data; 
      } catch (err) {
        return rejectWithValue(err.response.data);
      }
    }
  );

export const userDetails = createAsyncThunk(
  'user/details',
  async () => {
      const response = await axiosapi.get('/api/auth/me');
      return response.data;
  }
)

export const userLogout = createAsyncThunk(
  'user/logout',
  async () => {
      const response = await axiosapi.get('/api/auth/logout');
      return response.data;
  }
)

export const userProfile  = createAsyncThunk(
  'user/profile',
  async (formData, { rejectWithValue }) => {
    try{
      const response = await axiosapi.post('/api/auth/profile-update', formData);
      return response;
  }
  catch (err) {
    return rejectWithValue(err.response.data);
  }
})

export const userUpdatePassword = createAsyncThunk(
  'user/update-password',
  async (formData, { rejectWithValue }) => {
    try{
      const response = await axiosapi.post('/api/auth/change-password', formData);
      return response;
  }
  catch (err) {
    return rejectWithValue(err.response.data);
  }
}
)

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userLogin.fulfilled, (state, { payload }) => {
      if (payload.data.success === true) {
        state.isAuthenticated = true;
      }
    });
    builder.addCase(userDetails.fulfilled, (state, { payload }) => {
      if (payload.success === true) {
        state.isAuthenticated = true;
        state.user = payload.data;
      }
    });
    builder.addCase(userDetails.rejected, (state, { payload }) => {
      if (payload === undefined) {
        state.isAuthenticated = false;
        state.user = null;
      }
    });
    builder.addCase(userLogout.fulfilled, (state, { payload }) => {
      if (payload.data.success === true) {
        state.isAuthenticated = false;
        state.user = null;
      }
    });
    builder.addCase(userProfile.fulfilled, (state, { payload }) => {
      if (payload.data.success === true) {
        state.isAuthenticated = true;
        state.user = payload.data;
      }
    });
    builder.addCase(userUpdatePassword.fulfilled, (state, { payload }) => {
      if (payload.data.success === true) {
        state.isAuthenticated = true;
        state.user = payload.data.data;
      }
    });
  },
});

export default authSlice.reducer;
